/**
 * Utility to reset backend preference to Node.js
 * 
 * Run this in the browser console if you need to force reset:
 * ```
 * localStorage.setItem('evo-backend-type', 'nodejs');
 * window.location.reload();
 * ```
 */

export function resetBackendToNodeJS() {
  localStorage.setItem('evo-backend-type', 'nodejs');
  console.log('[Backend] Reset to Node.js backend. Reloading...');
  window.location.reload();
}

export function resetBackendToDotNet() {
  localStorage.setItem('evo-backend-type', 'dotnet');
  console.log('[Backend] Reset to .NET backend. Reloading...');
  window.location.reload();
}

export function clearBackendPreference() {
  localStorage.removeItem('evo-backend-type');
  console.log('[Backend] Cleared backend preference. Reloading...');
  window.location.reload();
}

// Make these available in the browser console for debugging
if (typeof window !== 'undefined') {
  (window as any).resetBackendToNodeJS = resetBackendToNodeJS;
  (window as any).resetBackendToDotNet = resetBackendToDotNet;
  (window as any).clearBackendPreference = clearBackendPreference;
}
